module.exports = __webpack_public_path__ + "images/sound_off_edbbb510e8b74158f7e495c3b6841bce.png";